/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.28/esri/copyright.txt for details.
*/
function t(t,n,o,s){const a=Math.cos(o);t[0]=Math.cos(n)*a*s,t[1]=Math.sin(n)*a*s,t[2]=Math.sin(o)*s}export{t as lonLatToSphericalPCPF};
